import type { TotalTripPricing } from "@b2bportal/air-booking-api";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Typography } from "@material-ui/core";
import clsx from "clsx";
import styles from "./styles.module.scss";

export const TripsFlightsConvenienceFee = ({
  additionalMargin,
}: {
  additionalMargin?: TotalTripPricing["additionalMargin"];
}) => {
  const { t, formatFiatCurrency } = useI18nContext();

  if (!additionalMargin?.fiat || additionalMargin.fiat.value === 0) return null;

  return (
    <div className={clsx("pricing-row", styles.convenienceFeeRow)}>
      <Typography className="label" variant="body2">
        {t("convenienceFee")}
      </Typography>
      <Typography className="price" variant="body2">
        {formatFiatCurrency(additionalMargin.fiat)}
      </Typography>
    </div>
  );
};
